import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=71bb435a&scoped=true"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=71bb435a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb435a",
  null
  
)

export default component.exports